export default __webpack_public_path__ + "static/media/btn-noten.355940e1.webp";